"use strict";

var _client = _interopRequireDefault(require("@walletconnect/client"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WalletInterface = require('../interface/walletInterface');

var Provider = require('../provider');

var SIGNALER_URL = 'https://bridge.walletconnect.org';
var ERROR = 'The connection was expired';

var Trust = /*#__PURE__*/function (_WalletInterface) {
  _inherits(Trust, _WalletInterface);

  var _super = _createSuper(Trust);

  /**
   * Constructor
   * @param {*} net 
   * @param {*} options - extra options for specific wallets
   * getAuthentication
   * getApproval
   */
  function Trust(net, options) {
    var _this;

    _classCallCheck(this, Trust);

    _this = _super.call(this, net, 'hybridwallet');
    /**
     * Init options
     */

    _defineProperty(_assertThisInitialized(_this), "setWallet", function (accOpts, callback) {
      _this.provider = new Provider.HybridWallet(_this.net);
      accOpts.approveTransaction = _this.getApproval;
      return _this.provider.init(accOpts, function (er, web3) {
        if (er) return callback(er, null);
        _this.web3 = web3;
        return callback(null, web3);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAccountByTrustWallet", function (callback) {
      var accOpts = {
        getAddress: _this.getAddress,
        signTransaction: _this.signTransaction,
        killSession: _this.killSession
      };

      if (_this.walletConnector.connected) {
        // Prevent double calls
        if (_this.walletConnector.preventDuplicatedEvents) return;
        _this.walletConnector.preventDuplicatedEvents = true;
        return _this.setWallet(accOpts, callback);
      }

      _this.walletConnector.createSession().then(function () {
        var code = _this.walletConnector.uri;
        return _this.getAuthentication.open(code, function (er, re) {
          // User close authentication modal
          if (er) return callback(er, null);
        });
      });

      return _this.walletConnector.on('connect', function (er, re) {
        if (er) return callback(er, null); // Prevent double calls

        if (_this.walletConnector.preventDuplicatedEvents) return;
        _this.walletConnector.preventDuplicatedEvents = true;

        _this.getAuthentication.close();

        if (!re || !re.params || !re.params[0] || !re.params[0].chainId) return callback('There is no wallet account', null);
        var chainId = re.params[0].chainId;
        if (_this.net !== chainId) return callback('Invalid network', null);
        return _this.setWallet(accOpts, callback);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAccountsByTrustWallet", function (callback) {
      return _this.getAddress(function (er, re) {
        if (er) return callback(er, null);
        return null, [re];
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAddress", function (callback) {
      if (_this.walletConnector.connected) return callback(null, _this.walletConnector.accounts[0]);
      return callback(ERROR, null);
    });

    _defineProperty(_assertThisInitialized(_this), "signTransaction", function (txParams, callback) {
      if (_this.walletConnector.connected) return _this.walletConnector.signTransaction(txParams).then(function (re) {
        return callback(null, re);
      }).catch(function (er) {
        return callback(er, null);
      });
      return callback(ERROR, null);
    });

    _defineProperty(_assertThisInitialized(_this), "killSession", function () {
      return _this.walletConnector.killSession();
    });

    var getAuthentication = options.getAuthentication,
        getApproval = options.getApproval;
    if (!getAuthentication || !getApproval) throw new Error('Invalid options');
    _this.getAuthentication = getAuthentication;
    _this.getApproval = getApproval;
    _this.walletConnector = new _client.default({
      bridge: SIGNALER_URL
    });
    _this.walletConnector.preventDuplicatedEvents = false;

    _this.walletConnector.on('session_update', function (er, re) {
      return console.log('RtcUpdatedEvent', er, re);
    });

    _this.walletConnector.on('disconnect', function (er, re) {
      _this.walletConnector.preventDuplicatedEvents = false;
      return console.log('RtcClosedEvent');
    });

    return _this;
  }
  /**
   * @func setWallet
   * (Internal function) Set up coinbase
   * @param {*} accOpts 
   */


  return Trust;
}(WalletInterface);

module.exports = Trust;